import React from 'react';
import { Table } from 'flowbite-react';
import { FaSort, FaSortUp, FaSortDown } from 'react-icons/fa';

const CustomTable = ({ columns, rows, actions, onSort, sortField, sortOrder, currentPage, rowsPerPage, t }) => {
    const renderSortIcon = (field) => {
        if (field === sortField) {
            return sortOrder === 'asc' ? <FaSortUp /> : <FaSortDown />;
        };
        
        return <FaSort />;
    };
    
    const hasActions = actions && rows.length > 0;
    
    return (
        <Table
            hoverable
            theme={{
                root: {
                    base: 'w-full border-b border-bg-platinum text-left text-xs md:text-sm',
                    shadow: 'absolute left-0 top-0 -z-10 h-full w-full',
                    wrapper: 'relative'
                },
                body: {
                    base: 'group/body divide-platinum divide-y',
                    cell: {
                        base: 'py-2'
                    },
                },
                head: {
                    base: 'group/head text-white',
                    cell: {
                        base: 'bg-primary',
                    },
                },
                row: {
                    base: 'group/row bg-white text-black',
                    hovered: 'hover:bg-platinum',
                    striped: 'odd:bg-white even:bg-platinum'
                },
            }}
        >
            <Table.Head>
                <Table.HeadCell className='pl-5 pr-2.5 py-2'>No.</Table.HeadCell>
                {columns.map((column) => (
                    <Table.HeadCell
                        key={column.field}
                        className={`p-2.5 ${column.sortable ? 'cursor-pointer' : ''}`}
                        onClick={() => column.sortable && onSort(column.field)}
                    >
                        <div className='flex items-center justify-between space-x-2'>
                            <span>{column.title}</span>
                            {column.sortable && renderSortIcon(column.field)}
                        </div>
                    </Table.HeadCell>
                ))}
                {hasActions && <Table.HeadCell className='pl-2.5 pr-5'></Table.HeadCell>}
            </Table.Head>
            <Table.Body>
                {rows.map((row, rowIndex) => (
                    <Table.Row key={rowIndex}>
                        <Table.Cell className='w-2 pl-5 pr-2.5 '>
                            {rowIndex + 1 + (currentPage - 1) * rowsPerPage}
                        </Table.Cell>
                        {columns.map((column) => (
                            <Table.Cell
                                key={column.field}
                                className='px-2.5 whitespace-nowrap'
                            >
                                {row[column.field]}
                            </Table.Cell>
                        ))}
                        {actions && (
                            <Table.Cell className='w-2 pl-2.5 pr-5'>
                                <div className='flex items-center justify-center space-x-2'>
                                    {actions.map((action, actionIndex) => (
                                        <React.Fragment key={actionIndex}>
                                            {action(row)}
                                        </React.Fragment>
                                    ))}
                                </div>
                            </Table.Cell>
                        )}
                    </Table.Row>
                ))}
                {rows.length === 0 && (
                    <Table.Row>
                        <Table.Cell colSpan={columns.length + (actions ? 1 : 0)} className='text-center'>
                            {t('table.noDataAvailable')}
                        </Table.Cell>
                    </Table.Row>
                )}
            </Table.Body>
        </Table>
    );
};

export default CustomTable;
